import { makeRivieraDataQueryPackage } from 'js/file_viewer/core/queries/riviera_base';
import { rivieraClient } from 'js/file_viewer/core/riviera/api';
const fetchLinkfileUri = async (args) => {
    var _a;
    const { previewMetadata } = args;
    if (((_a = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content) === null || _a === void 0 ? void 0 : _a['.tag']) !== 'linkfile' || !previewMetadata.content.url) {
        // useLinkfileUriQuery is disabled if !previewMetadata, so we won't hit this in the case where previewMetadata is
        // undefined.
        throw new Error('Invalid preview metadata provided for linkfile preview');
    }
    const { url, authenticated } = previewMetadata.content;
    const response = await rivieraClient.fetchLinkfileData(url, !!authenticated);
    if (response.error) {
        throw response.error;
    }
    return response.data.uri;
};
const linkfileQueryPackage = makeRivieraDataQueryPackage({
    fileTypeSpecificQueryFn: fetchLinkfileUri,
    fieldName: 'linkfile_uri',
});
export const prefetchLinkfileRivieraData = (queryClient, previewKey, previewMetadata) => {
    var _a;
    if (!previewKey || ((_a = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content) === null || _a === void 0 ? void 0 : _a['.tag']) !== 'linkfile') {
        return Promise.resolve();
    }
    return linkfileQueryPackage.prefetchQuery(queryClient, {
        apiArg: {
            previewKey,
            previewMetadata,
        },
        pkgArg: null,
    });
};
export const useLinkfileUriQuery = (previewKey, previewMetadata) => {
    const content = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content;
    const isLinkfile = (content === null || content === void 0 ? void 0 : content['.tag']) === 'linkfile';
    const result = linkfileQueryPackage.useQuery({
        apiArg: {
            previewKey,
            previewMetadata,
        },
        pkgArg: null,
    }, { enabled: !!previewKey && !!previewMetadata && isLinkfile });
    return result;
};
//# sourceMappingURL=linkfile.preenvesnextjs.map
